// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-a28923a1] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.app-details-toggle[data-v-a28923a1] {
  position: sticky;
  width: var(--default-clickable-area);
  height: var(--default-clickable-area);
  padding: calc((var(--default-clickable-area) - 16px) / 2);
  cursor: pointer;
  opacity: 0.6;
  transform: rotate(180deg);
  background-color: var(--color-main-background);
  z-index: 2000;
  top: var(--app-navigation-padding);
  inset-inline-start: calc(var(--default-clickable-area) + var(--app-navigation-padding) * 2);
}
.app-details-toggle--mobile[data-v-a28923a1] {
  inset-inline-start: var(--app-navigation-padding);
}
.app-details-toggle[data-v-a28923a1]:active, .app-details-toggle[data-v-a28923a1]:hover, .app-details-toggle[data-v-a28923a1]:focus {
  opacity: 1;
}/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-51427d61] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.app-content[data-v-51427d61] {
  position: initial;
  z-index: 1000;
  flex-basis: 100vw;
  height: 100%;
  margin: 0 !important;
  background-color: var(--color-main-background);
  min-width: 0;
}
.app-content[data-v-51427d61]:not(.app-content--has-list) {
  overflow: auto;
}
.app-content-wrapper[data-v-51427d61] {
  position: relative;
  width: 100%;
  height: 100%;
}
.app-content-wrapper--no-split.app-content-wrapper--show-list[data-v-51427d61]  .app-content-list {
  display: flex;
}
.app-content-wrapper--no-split.app-content-wrapper--show-list[data-v-51427d61]  .app-content-details {
  display: none;
}
.app-content-wrapper--no-split.app-content-wrapper--show-details[data-v-51427d61]  .app-content-list {
  display: none;
}
.app-content-wrapper--no-split.app-content-wrapper--show-details[data-v-51427d61]  .app-content-details {
  display: block;
}
[data-v-51427d61] .splitpanes.default-theme .app-content-list {
  max-width: none;
  /* Thin scrollbar is hard to catch on resizable columns */
  scrollbar-width: auto;
}
[data-v-51427d61] .splitpanes.default-theme .splitpanes__pane {
  background-color: transparent;
  transition: none;
}
[data-v-51427d61] .splitpanes.default-theme .splitpanes__pane-list {
  min-width: 300px;
  position: sticky;
}
@media only screen and (width < 1024px) {
[data-v-51427d61] .splitpanes.default-theme .splitpanes__pane-list {
    display: none;
}
}
[data-v-51427d61] .splitpanes.default-theme .splitpanes__pane-details {
  overflow-y: auto;
}
@media only screen and (width < 1024px) {
[data-v-51427d61] .splitpanes.default-theme .splitpanes__pane-details {
    min-width: 100%;
}
}
[data-v-51427d61] .splitpanes.default-theme .splitpanes__splitter {
  background-color: var(--color-main-background);
}
[data-v-51427d61] .splitpanes.default-theme .splitpanes__splitter::before,[data-v-51427d61] .splitpanes.default-theme .splitpanes__splitter::after {
  background-color: var(--color-border);
}
[data-v-51427d61] .splitpanes.default-theme.splitpanes--vertical .splitpanes__splitter {
  border-inline-start: 1px solid var(--color-border);
}
[data-v-51427d61] .splitpanes.default-theme.splitpanes--horizontal .splitpanes__splitter {
  border-top: 1px solid var(--color-border);
}
.app-content-wrapper--show-list[data-v-51427d61] .app-content-list {
  max-width: none;
}
.app-content-wrapper__list[data-v-51427d61] {
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcAppContent-TgcZd4AI.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,qCAAqC;EACrC,yDAAyD;EACzD,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,8CAA8C;EAC9C,aAAa;EACb,kCAAkC;EAClC,2FAA2F;AAC7F;AACA;EACE,iDAAiD;AACnD;AACA;EACE,UAAU;AACZ,CAAC;;;EAGC;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,8CAA8C;EAC9C,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,yDAAyD;EACzD,qBAAqB;AACvB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;AACA;IACI,aAAa;AACjB;AACA;AACA;EACE,gBAAgB;AAClB;AACA;AACA;IACI,eAAe;AACnB;AACA;AACA;EACE,8CAA8C;AAChD;AACA;EACE,qCAAqC;AACvC;AACA;EACE,kDAAkD;AACpD;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-a28923a1] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.app-details-toggle[data-v-a28923a1] {\n  position: sticky;\n  width: var(--default-clickable-area);\n  height: var(--default-clickable-area);\n  padding: calc((var(--default-clickable-area) - 16px) / 2);\n  cursor: pointer;\n  opacity: 0.6;\n  transform: rotate(180deg);\n  background-color: var(--color-main-background);\n  z-index: 2000;\n  top: var(--app-navigation-padding);\n  inset-inline-start: calc(var(--default-clickable-area) + var(--app-navigation-padding) * 2);\n}\n.app-details-toggle--mobile[data-v-a28923a1] {\n  inset-inline-start: var(--app-navigation-padding);\n}\n.app-details-toggle[data-v-a28923a1]:active, .app-details-toggle[data-v-a28923a1]:hover, .app-details-toggle[data-v-a28923a1]:focus {\n  opacity: 1;\n}/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-51427d61] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.app-content[data-v-51427d61] {\n  position: initial;\n  z-index: 1000;\n  flex-basis: 100vw;\n  height: 100%;\n  margin: 0 !important;\n  background-color: var(--color-main-background);\n  min-width: 0;\n}\n.app-content[data-v-51427d61]:not(.app-content--has-list) {\n  overflow: auto;\n}\n.app-content-wrapper[data-v-51427d61] {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.app-content-wrapper--no-split.app-content-wrapper--show-list[data-v-51427d61]  .app-content-list {\n  display: flex;\n}\n.app-content-wrapper--no-split.app-content-wrapper--show-list[data-v-51427d61]  .app-content-details {\n  display: none;\n}\n.app-content-wrapper--no-split.app-content-wrapper--show-details[data-v-51427d61]  .app-content-list {\n  display: none;\n}\n.app-content-wrapper--no-split.app-content-wrapper--show-details[data-v-51427d61]  .app-content-details {\n  display: block;\n}\n[data-v-51427d61] .splitpanes.default-theme .app-content-list {\n  max-width: none;\n  /* Thin scrollbar is hard to catch on resizable columns */\n  scrollbar-width: auto;\n}\n[data-v-51427d61] .splitpanes.default-theme .splitpanes__pane {\n  background-color: transparent;\n  transition: none;\n}\n[data-v-51427d61] .splitpanes.default-theme .splitpanes__pane-list {\n  min-width: 300px;\n  position: sticky;\n}\n@media only screen and (width < 1024px) {\n[data-v-51427d61] .splitpanes.default-theme .splitpanes__pane-list {\n    display: none;\n}\n}\n[data-v-51427d61] .splitpanes.default-theme .splitpanes__pane-details {\n  overflow-y: auto;\n}\n@media only screen and (width < 1024px) {\n[data-v-51427d61] .splitpanes.default-theme .splitpanes__pane-details {\n    min-width: 100%;\n}\n}\n[data-v-51427d61] .splitpanes.default-theme .splitpanes__splitter {\n  background-color: var(--color-main-background);\n}\n[data-v-51427d61] .splitpanes.default-theme .splitpanes__splitter::before,[data-v-51427d61] .splitpanes.default-theme .splitpanes__splitter::after {\n  background-color: var(--color-border);\n}\n[data-v-51427d61] .splitpanes.default-theme.splitpanes--vertical .splitpanes__splitter {\n  border-inline-start: 1px solid var(--color-border);\n}\n[data-v-51427d61] .splitpanes.default-theme.splitpanes--horizontal .splitpanes__splitter {\n  border-top: 1px solid var(--color-border);\n}\n.app-content-wrapper--show-list[data-v-51427d61] .app-content-list {\n  max-width: none;\n}\n.app-content-wrapper__list[data-v-51427d61] {\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
